﻿import { ajaxPost } from '../utils/ajax';

export default {
    saveInfo(url, data, callback, errorCallback) {
        if (url && url.length > 0) {
            ajaxPost(url, data, true)
                .then(callback)
                .catch(errorCallback);
        }
    },
    asyncPost(url, data, callback, errorCallback) {
        if (url && url.length > 0) {
            ajaxPost(url, data, true)
                .then(callback)
                .catch(errorCallback);
        }
    }
}
